'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _css = require('antd/lib/icon/style/css');

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _css2 = require('antd/lib/menu/style/css');

var _menu = require('antd/lib/menu');

var _menu2 = _interopRequireDefault(_menu);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 侧边栏导航菜单
 */

var SubMenu = _menu2.default.SubMenu;

// 侧边导航菜单
var SidebarMenu = _react2.default.createClass({
  displayName: 'SidebarMenu',
  render: function render() {
    return _react2.default.createElement(
      _menu2.default,
      {
        theme: 'dark',
        mode: 'inline',
        onClick: this.props.onClick,
        selectedKeys: [this.props.selectedKey],
        defaultOpenKeys: ['order', 'product', 'coupon', 'finance', 'user', 'shippment', 'media', 'setting', 'reseller']
      },
      _react2.default.createElement(
        _menu2.default.Item,
        { key: 'home' },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/' },
          _react2.default.createElement(_icon2.default, { type: 'area-chart' }),
          '\u63A7\u5236\u9762\u677F'
        )
      ),
      _react2.default.createElement(
        SubMenu,
        { key: 'order', title: _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_icon2.default, { type: 'mail' }),
            _react2.default.createElement(
              'span',
              null,
              '\u8BA2\u5355\u7BA1\u7406'
            )
          ) },
        _react2.default.createElement(
          _menu2.default.Item,
          { key: '1' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/orders' },
            '\u6240\u6709\u8BA2\u5355'
          )
        )
      ),
      _react2.default.createElement(
        SubMenu,
        { key: 'product', title: _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_icon2.default, { type: 'appstore-o' }),
            _react2.default.createElement(
              'span',
              null,
              '\u5546\u54C1\u7BA1\u7406'
            )
          ) },
        _react2.default.createElement(
          _menu2.default.Item,
          { key: '3' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/products' },
            '\u6240\u6709\u5546\u54C1'
          )
        ),
        _react2.default.createElement(
          _menu2.default.Item,
          { key: '4' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/templates' },
            '\u6240\u6709\u6A21\u7248'
          )
        )
      ),
      _react2.default.createElement(
        SubMenu,
        { key: 'coupon', title: _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_icon2.default, { type: 'calculator' }),
            _react2.default.createElement(
              'span',
              null,
              '\u4F18\u60E0\u5238\u7BA1\u7406'
            )
          ) },
        _react2.default.createElement(
          _menu2.default.Item,
          { key: '16' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/coupons' },
            '\u6240\u6709\u4F18\u60E0\u5238'
          )
        )
      ),
      _react2.default.createElement(
        SubMenu,
        { key: 'finance', title: _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_icon2.default, { type: 'pay-circle-o' }),
            _react2.default.createElement(
              'span',
              null,
              '\u8D22\u52A1\u7BA1\u7406'
            )
          ) },
        _react2.default.createElement(
          _menu2.default.Item,
          { key: '5' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/finances' },
            '\u4EA4\u6613\u660E\u7EC6'
          )
        ),
        _react2.default.createElement(
          _menu2.default.Item,
          { key: '6' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/inout' },
            '\u6536\u652F\u7EDF\u8BA1'
          )
        )
      ),
      _react2.default.createElement(
        SubMenu,
        { key: 'user', title: _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_icon2.default, { type: 'user' }),
            _react2.default.createElement(
              'span',
              null,
              '\u5BA2\u6237\u7BA1\u7406'
            )
          ) },
        _react2.default.createElement(
          _menu2.default.Item,
          { key: '8' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/users' },
            '\u5BA2\u6237\u5217\u8868'
          )
        ),
        _react2.default.createElement(
          _menu2.default.Item,
          { key: '9' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/levels' },
            '\u5BA2\u6237\u7B49\u7EA7'
          )
        )
      ),
      _react2.default.createElement(
        SubMenu,
        { key: 'reseller', title: _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_icon2.default, { type: 'shop' }),
            _react2.default.createElement(
              'span',
              null,
              '\u7EBF\u4E0B\u5E97\u94FA\u7BA1\u7406'
            )
          ) },
        _react2.default.createElement(
          _menu2.default.Item,
          { key: '17' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/resellers' },
            'reseller\u5217\u8868'
          )
        ),
        _react2.default.createElement(
          _menu2.default.Item,
          { key: '18' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/withdraws' },
            '\u63D0\u73B0\u7533\u8BF7\u5217\u8868'
          )
        )
      ),
      _react2.default.createElement(
        SubMenu,
        { key: 'shippment', title: _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_icon2.default, { type: 'rocket' }),
            _react2.default.createElement(
              'span',
              null,
              '\u914D\u9001\u7BA1\u7406'
            )
          ) },
        _react2.default.createElement(
          _menu2.default.Item,
          { key: '10' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/express' },
            '\u7269\u6D41\u5FEB\u9012'
          )
        ),
        _react2.default.createElement(
          _menu2.default.Item,
          { key: '11' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/pickup' },
            '\u4E0A\u95E8\u81EA\u63D0'
          )
        )
      ),
      _react2.default.createElement(
        SubMenu,
        { key: 'media', title: _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_icon2.default, { type: 'file' }),
            _react2.default.createElement(
              'span',
              null,
              '\u5A92\u4F53\u5E93'
            )
          ) },
        _react2.default.createElement(
          _menu2.default.Item,
          { key: '12' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/media' },
            '\u67E5\u770B'
          )
        ),
        _react2.default.createElement(
          _menu2.default.Item,
          { key: '15' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/banner' },
            'banner\u56FE\u7BA1\u7406'
          )
        )
      ),
      _react2.default.createElement(
        SubMenu,
        { key: 'setting', title: _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_icon2.default, { type: 'setting' }),
            _react2.default.createElement(
              'span',
              null,
              '\u8BBE\u7F6E'
            )
          ) },
        _react2.default.createElement(
          _menu2.default.Item,
          { key: '14' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/account' },
            '\u4E2A\u4EBA\u8BBE\u7F6E'
          )
        )
      )
    );
  }
});

exports.default = SidebarMenu;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/sidebar_menu.js
// module id = 971
// module chunks = 0